import { createContext, useContext } from 'react';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DialogContext = createContext(undefined);
export function useDialogContext() {
    const context = useContext(DialogContext);
    if (context == undefined) throw new Error('DialogContext is missing — components like DialogTitle must be rendered inside a Dialog');
    return context;
}
